module.exports = {
	"posesList": {
		"item1": {
			"id": "item1",
			"title": "New pose",
			"poseType": "",
			"promptType": "",
			"instagramId": "",
			"photographer": "",
			"description": "",
			"prompt": "",
			"sliderIsEnabled": false,
			"imageUrl": "https://i.pinimg.com/originals/27/b7/32/27b7327fba58f1cd9b96cedc37b57c5f.jpg",
			"sliderImages": [
				{
					"imageUrl": "https://firebasestorage.googleapis.com/v0/b/unposed-5aadf.appspot.com/o/1540986744087.jpg?alt=media&token=ba75d446-e257-4129-8b1b-776210ba3f28",
					"instagramId": "cedarandsaltphotography"
				}
			]
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/schema.json
// module id = 830
// module chunks = 0